import i18n from 'i18n';

const FORM_TITLE = i18n.t('addRate', { ns: 'rates' });

const SHIPOWNER_LABEL = i18n.t('shipowner', { ns: 'rates' });
const CONTRACT_NUMBER_LABEL = i18n.t('contractNumber', { ns: 'rates' });
const COMMODITY_LABEL = i18n.t('commodity', { ns: 'rates' });
const NAMED_ACCOUNT_LABEL = i18n.t('namedAccount', { ns: 'rates' });
const ROUTE_FROM_LABEL = i18n.t('routeFrom', { ns: 'rates' });
const ROUTE_TO_LABEL = i18n.t('routeTo', { ns: 'rates' });
const CONTAINER_TYPE_LABEL = i18n.t('containerType', { ns: 'rates' });
const ACTIVITY_LABEL = i18n.t('activity', { ns: 'rates' });
const RATE_ALL_IN_LABEL = i18n.t('rateAllIn', { ns: 'rates' });
const EXPIRATION_DATE_FROM_LABEL = i18n.t('expirationDateFrom', {
  ns: 'rates',
});
const EXPIRATION_DATE_TO_LABEL = i18n.t('expirationDateTo', { ns: 'rates' });
const DAYS_OFF_LABEL = i18n.t('daysOff', { ns: 'rates' });
const SEA_FREIGHT = i18n.t('seaFreight', { ns: 'rates' });
const INTERNAL_NOTE_LABEL = i18n.t('internalNote', { ns: 'rates' });
const RELATION_LABEL = i18n.t('relation', { ns: 'rates' });
const COST_LABEL = i18n.t('cost', { ns: 'rates' });
const CURRENCY_LABEL = i18n.t('currency', { ns: 'rates' });
const UNIT_LABEL = i18n.t('unit', { ns: 'rates' });

const FIELD_REQUIRED_ERROR = i18n.t('required', { ns: 'validation' });
const FIELD_MIN_ZERO_ERROR = i18n.t('min', {
  ns: 'validation',
  replace: { '0': '0' },
});

const SAVE_BUTTON_LABEL = i18n.t('save', { ns: 'rates' });
const ADD_NEW_ACTIVITY_BUTTON = i18n.t('addNewActivity', { ns: 'rates' });
const CANCEL_BUTTON = i18n.t('button.cancel', { ns: 'misc' });
const ADD_RATE_BUTTON = i18n.t('addRate', { ns: 'rates' });

const EDIT_SUCCESS_TOAST = i18n.t('editSuccess', { ns: 'rates' });
const CREATE_ERROR_TOAST = i18n.t('message.generalError', { ns: 'misc' });

const DUPLICATE_SUCCESS_TOAST = i18n.t('duplicateSuccess', {
  ns: 'rates',
});
const DUPLICATE_ERROR_TOAST = i18n.t('duplicateFailure', { ns: 'rates' });

export {
  SAVE_BUTTON_LABEL,
  FORM_TITLE,
  SHIPOWNER_LABEL,
  CONTRACT_NUMBER_LABEL,
  COMMODITY_LABEL,
  NAMED_ACCOUNT_LABEL,
  ROUTE_FROM_LABEL,
  ROUTE_TO_LABEL,
  CONTAINER_TYPE_LABEL,
  ACTIVITY_LABEL,
  RATE_ALL_IN_LABEL,
  EXPIRATION_DATE_FROM_LABEL,
  EXPIRATION_DATE_TO_LABEL,
  DAYS_OFF_LABEL,
  INTERNAL_NOTE_LABEL,
  ADD_NEW_ACTIVITY_BUTTON,
  FIELD_REQUIRED_ERROR,
  FIELD_MIN_ZERO_ERROR,
  CANCEL_BUTTON,
  ADD_RATE_BUTTON,
  CREATE_ERROR_TOAST,
  DUPLICATE_SUCCESS_TOAST,
  DUPLICATE_ERROR_TOAST,
  SEA_FREIGHT,
  RELATION_LABEL,
  COST_LABEL,
  CURRENCY_LABEL,
  UNIT_LABEL,
  EDIT_SUCCESS_TOAST,
};
